'use strict';

/* Views */
import stylesEdit from './edit/style-edit.component';

/* Module */
export default angular.module('conduu.ap.styles', [stylesEdit])
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/styles/index.js